import { createSvgIcon } from '@mui/material';

export const AlphaECircle = createSvgIcon(
  <path d="M12,2A10,10 0 0,1 22,12A10,10 0 0,1 12,22A10,10 0 0,1 2,12A10,10 0 0,1 12,2M9,7V17H15V15H11V13H15V11H11V9H15V7H9Z" />,
  'AlphaECircle',
);
